import { createContext } from 'react';

export default createContext<string | undefined>(undefined);
